import { Pause, Play, Loader2 } from "lucide-react";

export const PlayPauseIcon = ({ playing, loading, className = "h-5 w-5" }) =>
  loading ? <Loader2 className={`${className} animate-spin`} /> : playing ? <Pause className={className} fill="currentColor" /> : <Play className={`${className} translate-x-[1px]`} fill="currentColor" />;

export const Cover = ({ track, className = "h-12 w-12 rounded-lg" }) => (
  <div className={`${className} shrink-0 overflow-hidden bg-nw-surface ring-1 ring-white/10`}>
    {track?.cover_url && <img src={`${process.env.REACT_APP_BACKEND_URL}${track.cover_url}`} alt={track.title} className="h-full w-full object-cover" loading="lazy" />}
  </div>
);
